import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep} from "../../../../redux/actions/tourActions";
import {KEY_LOCAL_STORAGE_FLAG_STEP_ONE, STEPS} from "../../helpers";
import './TourFirstStep.scss';
import {Tour} from "antd";
import {useTourActions} from "../../hooks";

const TourFirstStep = ({openSettingsModal}) => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const {handleClickNextStep2List} = useTourActions();
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if ([STEPS.ONE].includes(activeStep)) {
            setTimeout(() => {
                localStorage.setItem(KEY_LOCAL_STORAGE_FLAG_STEP_ONE, true);
                setIsOpen(true)
            }, 500)
        } else {
            setIsOpen(false)
        }
    }, [activeStep])

    const steps = [
        {
            title: t('tour_step_1'),
            description: t('tour_step_1_desc'),
            target: () => document.querySelector(`.calendar`),
            nextButtonProps: {
                children: (
                    <div className="button-next">
                        <div
                            className="button-next--later"
                            onClick={() => {
                                setIsOpen(false);
                                handleClickNextStep2List();
                            }}
                        >
                            {t('later')}
                        </div>
                        <span className="button-next--next" onClick={(e) => {
                            openSettingsModal();
                        }}
                        >
                            {t('connect')}
                        </span>
                    </div>
                ),
            },
            prevButtonProps: {
                children: <span>{t('later')}</span>,
                onClick: () => {
                    localStorage.removeItem(KEY_LOCAL_STORAGE_FLAG_STEP_ONE);
                    dispatch(UpdateActiveStep(STEPS.TWO))
                }
            }
        }
    ];

    return (
        <Tour
            rootClassName={'tour-first'}
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false);
                localStorage.removeItem(KEY_LOCAL_STORAGE_FLAG_STEP_ONE);
            }}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourFirstStep;